import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "suspended-shell" }
const _hoisted_2 = { class: "suspended-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"suspended-icon\" data-v-8abfe89c><svg width=\"56\" height=\"56\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8abfe89c><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-8abfe89c></circle><line x1=\"4.93\" y1=\"4.93\" x2=\"19.07\" y2=\"19.07\" data-v-8abfe89c></line></svg></div><h1 class=\"suspended-title\" data-v-8abfe89c>Obra suspensa</h1><p class=\"suspended-desc\" data-v-8abfe89c> O acesso a esta obra está temporariamente suspenso.<br data-v-8abfe89c> Entre em contato com o administrador para mais informações. </p>", 3)),
      _createElementVNode("button", {
        class: "btn-back",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }, "Voltar para a página inicial")
    ])
  ]))
}